module.exports = __webpack_public_path__ + "img/figure-10.467c21a7.png";